import { defineMessages } from 'utils/intl';

export default defineMessages({
  header: 'Masz pytania? Doradzimy!',
  ourBrands: 'Nasze marki:',
});
